import { ContactResourceType } from '@principle-theorem/principle-core/interfaces';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  IBigQueryNote,
  IBigQueryInteraction,
  ITimestampedDimension,
} from './common';

interface IBigQueryContactableDetails {
  email: string;
  address: string;
  phone: string;
}

export interface IBigQueryContactDetails
  extends Partial<IBigQueryContactableDetails> {
  name: string;
  mobileNumber?: string;
  jobTitle?: string;
}

export interface IContactDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    IBigQueryContactable,
    ITimestampedDimension {}

export interface IBigQueryContactable extends IBigQueryContactDetails {
  notes: IBigQueryNote[];
  interactions: IBigQueryInteraction[];
  parentRef?: IContactRef;
}

interface IContactRef extends IBigQueryNamedDocument {
  type: ContactResourceType;
}
